<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Upload {{ title }}
        <v-spacer />
        <v-btn
          icon
          @click="onCancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-file-input
          v-model="files"
          accept=".png, .jpeg, .jpg"
          label="Enviar arquivo"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="d-flex align-end mb-2"
          text="text"
          color="primary"
          @click="onSubmit"
        >
          <v-icon>
            mdi-plus
          </v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true }
  },

  data: () => ({
    files: []
  }),
  methods: {
    // onSubmit () {
    //   const formData = new FormData()
    //   formData.append('file', this.files)
    //   this.$emit('resolve', formData)
    // },
    onSubmit () {
      const file = Array.isArray(this.files) ? this.files[0] : this.files
      if (!file) return
      this.$emit('resolve', file)
    },

    onCancel () {
      this.$emit('resolve', false)
    }
  }
}
</script>
